import { DialogTypes } from '@components/ui/dialog';

import type { ComponentType } from 'svelte';

export const getDialog = async (type: DialogTypes | undefined): Promise<ComponentType> => {
    switch (type) {
        case DialogTypes.Login:
            return (await import('@components/layout/auth')).Login;
        case DialogTypes.SpinnerDialog:
            return (await import('@components/payment/dialog/spinner-dialog')).SpinnerDialog;
        case DialogTypes.VpnDetected:
            return (await import('@components/layout/auth/vpn-detected')).VpnDetected;
        case DialogTypes.Signup:
            return (await import('@components/layout/auth')).Signup;
        case DialogTypes.UserAgreement:
            return (await import('@components/signup/user-agreement-dialog')).UserAgreementDialog;
        case DialogTypes.RatingOperator:
            return ((await import('@components/rating/operator-dialog')).RatingOperatorDialog);
        case DialogTypes.RatingUser:
            return ((await import('@components/rating/user-dialog')).RatingUserDialog);
        case DialogTypes.GiftChoose:
            return (await import('@components/room/gift/choose-dialog')).GiftChooseDialog;
        case DialogTypes.GiftConfirm:
            return (await import('@components/room/gift/confirm-dialog')).GiftConfirmDialog;
        case DialogTypes.SelfInfo:
            return (await import('@components/signup/self-info-dialog')).SelfInfoDialog;
        case DialogTypes.Income:
            return (await import('@components/layout/header/components/income-dialog')).IncomeDialog;
        case DialogTypes.BuyMembership:
            return (await import('@components/payment/dialog')).BuyMembershipDialog;
        case DialogTypes.BuyMinutes:
            return (await import('@components/payment/dialog')).BuyMinutesDialog;
        case DialogTypes.ReportReasons:
            return (await import('@components/room/reportReasons')).ReportReasonsDialog;
        case DialogTypes.ResetPassword:
            return (await import('@components/layout/auth/reset-password')).ResetPasswordDialog;
        case DialogTypes.ResetPasswordLinkSent:
            return (await import('@components/layout/auth/reset-password')).ResetPasswordSentDialog;
        case DialogTypes.Confirm:
            return (await import('@components/common/confirm-dialog')).ConfirmDialog;
        case DialogTypes.DeactivateAccount:
            return (await import('@components/profile/forms/deactivate/components')).DeactivateDialog;
        case DialogTypes.DeleteAccount:
            return (await import('@components/profile/forms/deactivate/components')).DeleteDialog;
        case DialogTypes.DisablePackageMinutesAutoRenew:
            return (await import('@components/payment/dialog')).DisableMinutesDialog;
        case DialogTypes.UserNote:
            return (await import('@components/user-note')).UserNoteFormDialog;
        default:
            throw new Error(`Unknown dialog type: ${type}`);
    }
};